import '../../css/App.css'
import '../../css/PageTemplate.css'
import {useContext, useEffect} from 'react'
import {AppContext} from "../context/AppContext";
import {AddAssetContext} from "../context/AddAssetContext";
import {IAddAssetForm, IAddAssetFormValidation, IConfiguration, IAuth} from '../../interfaces/interface';
import {IMessageSender, IMessageErrorResponse} from '../../interfaces/messageInterface';
import AddAssetForm from './AddAssetForm'
import PopMessage from '../PopMessage/PopMessage';
import axios from 'axios';
import HeaderTemplate from '../HeaderTemplate';

function AddAsset() {

    const {aAForm, formVal, defaultValueSelect, valueSelect, errMessage} = useContext(AddAssetContext);
    const {
        navBarStatus,
        config,
        authorization,
        disMessage,
        navBarHandler,
        errorHandlerFunction
    } = useContext(AppContext);
    const [auth]: IAuth[] = authorization;
    const [isNavbarOpen] = navBarStatus;
    const navBarClickHandler: (e: any) => void = navBarHandler
    const [, setConfiguration]: React.Dispatch<React.SetStateAction<IConfiguration>>[] = config;
    const [configuration]: IConfiguration[] = config
    const [formInput]: IAddAssetForm[] = aAForm;
    const [, setFormInput]: React.Dispatch<React.SetStateAction<IAddAssetForm>>[] = aAForm;
    const [displayMessage]: string[] = disMessage;
    const [, setDisplayMessage]: React.Dispatch<React.SetStateAction<string>>[] = disMessage;
    const [formFieldsValid]: IAddAssetFormValidation[] = formVal;
    const [, setFormFieldsValid]: React.Dispatch<React.SetStateAction<IAddAssetFormValidation>>[] = formVal;
    const [, setDefaultSelectValue]: React.Dispatch<React.SetStateAction<string>>[] = defaultValueSelect;
    const [, setSelectValue]: React.Dispatch<React.SetStateAction<string>>[] = valueSelect;
    const [errorMessage]: string[] = errMessage;
    const [, setErrorMessage]: React.Dispatch<React.SetStateAction<string>>[] = errMessage;
    const errorHandler: (status: number) => string = errorHandlerFunction;


    const addAssetHandler = (): void => {
        console.log(formInput);

        let messageBody: IMessageSender = {
            type: 'addAsset',
            userId: auth.username,
            assetInfo: formInput
        }
        setDisplayMessage("processing");
        axios.post('/message', messageBody, auth.header
        ).then(res => {
            if (res.data.status === "OK") {
                setDisplayMessage("done");
                setFormInput({
                    assetName: "",
                    deviceId: "",
                    assetType: "",
                    assetDescription: "",
                    profile: "",
                    state: ""
                })
                setSelectValue("")
                setDefaultSelectValue("")
                let tempFormFieldsValid = formFieldsValid
                Object.entries(formFieldsValid).forEach(([key, value]) => {
                    if (key === "assetName" || key === "deviceId" ||
                        key === "assetType" || key === "assetDescription"
                    ) {
                        tempFormFieldsValid[key] = {
                            isValid: false,
                            displayMessage: false,
                            message: ""
                        }
                    }
                })
                setFormFieldsValid(tempFormFieldsValid)
            } else {
                if (res.data.errorDescription.startsWith("Asset name")) {
                    setFormFieldsValid({
                        ...formFieldsValid,
                        assetName: {
                            isValid: false,
                            displayMessage: true,
                            message: res.data.errorDescription
                        }
                    })
                    setDisplayMessage("none");
                } else if (res.data.errorDescription.startsWith("Device")) {
                    setFormFieldsValid({
                        ...formFieldsValid,
                        deviceId: {
                            isValid: false,
                            displayMessage: true,
                            message: res.data.errorDescription
                        }
                    })
                    setDisplayMessage("none");
                } else {
                    setErrorMessage(res.data.errorDescription)
                    setDisplayMessage("error");
                }
            }
        }).catch(({response}: IMessageErrorResponse) => {
            const errorMessage = errorHandler(response.data.status)
            setErrorMessage(errorMessage)
            setDisplayMessage("error");
        })
        if (!configuration.assetTypes.includes(formInput.assetType)) {
            setConfiguration({
                ...configuration,
                assetTypes: [...configuration.assetTypes, formInput.assetType]
            })

        }
    }

    return (
        <div className='page-template AddAsset' onClick={navBarClickHandler}>
            <HeaderTemplate title="Single Tracker Activation"/>
            {
                displayMessage !== "processing" &&
                <div
                    className={(displayMessage !== "none" || isNavbarOpen === true) ? 'page-template-main blur' : 'page-template-main'}
                    onClick={navBarClickHandler}>
                    <AddAssetForm/>
                </div>
            }
            {displayMessage !== "none" &&
                <div className='page-template-pop-message'>
                    <PopMessage
                        assetHandler={addAssetHandler}
                        formData={formInput}
                        type={"general"}
                        error={errorMessage}
                    />
                </div>
            }
        </div>
    );
}

export default AddAsset;


